import { useState } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta10({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const [seleccionadas, setSeleccionada] = useState([]);
	const [btn1, setBtn1] = useState(false);
	const [btn2, setBtn2] = useState(false);
	const [btn3, setBtn3] = useState(false);
	const [btn4, setBtn4] = useState(false);
	const [correctas] = useState(['d) Todas las anteriores.']);

	const grabarSeleccionada = (opc) => {
		const array = seleccionadas;
		array.push(opc);
		array.sort();
		setSeleccionada(array);
	};

	const siguiente = () => {
		if (seleccionadas.toString() === correctas.toString()) {
			setRespuesta('pregunta10', seleccionadas, 1);
			console.log('si');

			sumarPuntos(1);
		} else {
			setRespuesta('pregunta10', seleccionadas, 0);
			console.log('no');

			sumarPuntos(0);
		}
		cambiarPregunta(11);
	};

	const seleccionarOpcion = (btn) => {
		if (btn === 1) {
			setBtn1(!btn1);
			setBtn2(false);
			setBtn3(false);
			setBtn4(false);
		}
		if (btn === 2) {
			setBtn1(false);
			setBtn2(!btn2);
			setBtn3(false);
			setBtn4(false);
		}
		if (btn === 3) {
			setBtn1(false);
			setBtn2(false);
			setBtn3(!btn3);
			setBtn4(false);
		}
		if (btn === 4) {
			setBtn1(false);
			setBtn2(false);
			setBtn3(false);
			setBtn4(!btn4);
		}
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>10.</div> Uno de tus asesores está constantemente retrasado en el seguimiento de clientes, lo que afecta los cierres de ventas. ¿Qué enfoque utilizarías para darle feedback efectivo?
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn1 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								seleccionarOpcion(1);
								grabarSeleccionada('a) Hechos: Resaltar cómo los retrasos afectan la experiencia del cliente y el desempeño del equipo.');
							}}
						>
							<div className='letra'>{`a)`}</div>
							<div className='texto-respuesta'>Hechos: Resaltar cómo los retrasos afectan la experiencia del cliente y el desempeño del equipo.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn2 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								seleccionarOpcion(2);
								grabarSeleccionada('b) Acompañamiento: Proporcionar una guía paso a paso para mejorar sus tiempos de respuesta.');
							}}
						>
							<div className='letra'>{`b)`}</div>
							<div className='texto-respuesta'>Acompañamiento: Proporcionar una guía paso a paso para mejorar sus tiempos de respuesta.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn3 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								seleccionarOpcion(3);
								grabarSeleccionada('c) Seguimiento: Evaluar regularmente sus avances y ajustar las estrategias según sea necesario.');
							}}
						>
							<div className='letra'>{`c)`}</div>
							<div className='texto-respuesta'> Seguimiento: Evaluar regularmente sus avances y ajustar las estrategias según sea necesario.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn4 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								seleccionarOpcion(4);
								grabarSeleccionada('d) Todas las anteriores.');
							}}
						>
							<div className='letra'>{`d)`}</div>
							<div className='texto-respuesta'> Todas las anteriores.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
